// extracted by mini-css-extract-plugin
export default {"sidebarMenu":"Sidebar_sidebarMenu__aqHTO","active":"Sidebar_active__f18cI"};